import { css, styled } from 'styled-components';

export const SelectedItem = styled.div`
  padding: 2px 8px;
  margin: 1px;
  background-color: #11465d;
  color: #fff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  font-size: 15px;
`;

export const RemoveButton = styled.span`
  display: flex;
  margin-left: 5px;
  cursor: pointer;
`;
